/* Shipabob Supply theme JS */
(function () {
  'use strict';

  /* ----- Mobile menu toggle ----- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  if (menuToggle && menuDrawer) {
    menuToggle.addEventListener('click', function () {
      var open = menuDrawer.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  /* ----- Close desktop nav dropdowns on outside click ----- */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.site-nav__details[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  /* ----- Quantity steppers ----- */
  document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
    var input = wrap.querySelector('.quantity__input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(parseInt(input.min, 10) || 1, value - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Math.min(parseInt(input.max, 10) || Infinity, (parseInt(input.value, 10) || 1) + 1);
      });
    }
  });

  /* ----- Product page: variant picker, price, gallery ----- */
  var productPage = document.querySelector('[data-product-page]');
  if (productPage) {
    var variantDataEl = productPage.querySelector('[data-variant-data]');
    var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    var optionSelects = Array.prototype.slice.call(productPage.querySelectorAll('[data-option-select]'));
    var variantIdInput = productPage.querySelector('[data-variant-id]');
    var priceWrapper = productPage.querySelector('[data-price-wrapper]');
    var addButton = productPage.querySelector('[data-add-button]');
    var addLabel = productPage.querySelector('[data-add-label]');
    var mainImage = productPage.querySelector('[data-main-image]');

    function currentVariant() {
      var selected = optionSelects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === selected[index]; });
      });
    }

    function renderVariant() {
      var variant = currentVariant();
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
        }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      document.dispatchEvent(new CustomEvent('shipabob:variant-change', { detail: variant }));
      if (priceWrapper) {
        var html = '<span class="price' + (variant.compare_at_price ? ' price--on-sale' : '') + '">' +
          '<span class="price__current">' + variant.price + '</span>';
        if (variant.compare_at_price) {
          html += '<s class="price__compare">' + variant.compare_at_price + '</s>';
        }
        html += '</span>';
        priceWrapper.innerHTML = html;
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (variant.image && mainImage) {
        if (variant.image_srcset) mainImage.srcset = variant.image_srcset;
        else mainImage.removeAttribute('srcset');
        mainImage.src = variant.image;
        if (variant.image_alt) mainImage.alt = variant.image_alt;
      }
      // Keep the URL shareable for the selected variant.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        if (productPage.hasAttribute('data-variant-paths') && variant.variant_url) {
          url.pathname = new URL(variant.variant_url, window.location.origin).pathname;
          url.searchParams.delete('variant');
          url.searchParams.delete('option_values');
          if (url.toString() !== window.location.href) window.history.pushState({ variantId: variant.id }, '', url.toString());
        } else {
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', renderVariant);
    });

    /* Thumbnail gallery */
    productPage.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        if (thumb.dataset.sizes) mainImage.sizes = thumb.dataset.sizes;
        if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
        else mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.full;
        if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;
        productPage.querySelectorAll('[data-thumb]').forEach(function (other) {
          other.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----- Collection sort ----- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ----- Collection filter drawer ----- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  var filterOverlay = document.querySelector('.collection-filter-overlay');
  var filterCloseButtons = document.querySelectorAll('[data-filter-close]');

  function setFilterDrawer(open) {
    if (!filterDrawer || !filterToggle) return;
    filterDrawer.classList.toggle('is-open', open);
    if (filterOverlay) filterOverlay.classList.toggle('is-open', open);
    document.body.classList.toggle('filter-drawer-open', open);
    filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var closeButton = filterDrawer.querySelector('[data-filter-close]');
      if (closeButton) closeButton.focus();
    } else {
      filterToggle.focus();
    }
  }

  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener('click', function () { setFilterDrawer(true); });
    filterCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () { setFilterDrawer(false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && filterDrawer.classList.contains('is-open')) setFilterDrawer(false);
    });
  }

  /* ----- Address forms: preselect country ----- */
  document.querySelectorAll('[data-address-country]').forEach(function (select) {
    var defaultValue = select.dataset.default;
    if (defaultValue) select.value = defaultValue;
  });

  /* ----- Address delete confirmation ----- */
  document.querySelectorAll('[data-confirm-delete]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.confirm('Delete this address?')) event.preventDefault();
    });
  });
})();
